import React from 'react';
import { Text } from 'react-native';
import type { ThemeType } from 'types/index.d';
import { ThemeContext } from '../../index';

//Themed Text, shorthand
export const TT = (props :any) => {
  <ThemeContext.Consumer>
    {(value: ThemeType) => { return(<Text style={value.text}>{props.children}</Text>)}}
  </ThemeContext.Consumer>
}

//Themed bold text.
export const TB = (props: any) => {
  <ThemeContext.Consumer>
    {(value: ThemeType) => <Text style={value.text_bold}>{props.children}</Text>}
  </ThemeContext.Consumer>

}

//Themed italic text
export const TI = (props : any) => {
  <ThemeContext.Consumer>
    {(value:ThemeType) => <Text style={value.text_italic}>{props.children}</Text>}
  </ThemeContext.Consumer>

}

//Themed Italic Bold
export const TIB = (props:any) => {
  <ThemeContext.Consumer>
    {(value:ThemeType) => <Text style={[value.text_italic,value.text_bold]}>{props.children}</Text>}
  </ThemeContext.Consumer>

} 